"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchHistorySnapshotSchema = exports.SearchHistoryItemSchema = void 0;
var _zod = require("zod");
const SearchHistoryItemSchema = exports.SearchHistoryItemSchema = _zod.z.object({
  text: _zod.z.string(),
  url: _zod.z.string().optional(),
  timestamp: _zod.z.number()
});
const SearchHistorySnapshotSchema = exports.SearchHistorySnapshotSchema = _zod.z.object({
  version: _zod.z.string(),
  items: _zod.z.array(SearchHistoryItemSchema)
});
